import { http } from '@/utils'
import type { IAdvertisingItem } from './types'

//获取未读数量
export const getUnReadApi = (data: {
  cate_id: 5
}): Promise<{
  unread_num: number
  work_order_unprocessed_count: number
}> => {
  return http.post('/api/article/get_unread_num', data)
}

//弹窗广告列表
export const getAdvertisingApi = (): Promise<IAdvertisingItem[]> => {
  return http.post('/api/campaign/popupads_list')
}

//弹窗广告显示或者点击计数
export const getAdvertisingClickApi = (data: {
  popupads_id: number
  type: '1' | '2' //1显示 2点击
}): Promise<string[]> => {
  return http.post('/api/campaign/popupads_click', data)
}
